import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarLoggedIn from "./NavbarLoggedIn";
import NavbarLoggedOut from "./NavbarLoggedOut";
import "../CSS/navbar.css";
import logo from "../../logo-white.png";
import AuthContext from "../../context/AuthContext";
import useWindowDimensions from "../utility/windowDimensions";

export default function Navbar() {
  const { width } = useWindowDimensions();
  const [classNameNav, setClassNav] = useState("navbar sticky-top navbar-expand-lg navbar-light");
  const [classNameBrand, setClassBrand] = useState("navbar-brand");
  const [classNameNavToggler, setClassNavToggler] = useState("navbar-toggler-icon");

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setClassNav("navbar sticky-top navbar-expand-lg navbar-light scrolled");
      setClassBrand("navbar-brand scrolled");
      setClassNavToggler("navbar-toggler-icon scrolled");
    } else {
      setClassNav("navbar sticky-top navbar-expand-lg navbar-light");
      setClassBrand("navbar-brand");
      setClassNavToggler("navbar-toggler-icon");
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <AuthContext.Consumer>
      {({ user }) => (
        <nav className={classNameNav}>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className={classNameNavToggler}></span>
          </button>
          {
          width <= 990 && 
          <div data-toggle="collapse" >
            <Link  to="/" className={classNameBrand}>
              <img
                src={logo}
                height="40vmin"
                className="navbar-logo"
                alt="logo"
                loading="lazy"
              />
              MADADGAAR
            </Link>
          </div>
          }
          <div className="collapse navbar-collapse" id={`${width <= 990 ? "navbarTogglerDemo01" : ""}`} data-toggle={`${width <= 990 ? "collapse" : ""}`} data-target={`${width <= 990 ? "#navbarTogglerDemo01" : ""}`}>
            <Link  to="/" className={classNameBrand} style={{display: width > 990 ? 'block' : 'none'}}>
              <img
                src={logo}
                height="40vmin"
                className="navbar-logo"
                alt="logomobile"
                loading="lazy"
              />
              MADADGAAR
            </Link>
            {user ? <NavbarLoggedIn /> : <NavbarLoggedOut />}
          </div>
        </nav>
      )}
    </AuthContext.Consumer>
  );
}
